module.exports = __webpack_public_path__ + "assets/img/ios-portrait.5bc3e32.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/ios-portrait.png
// module id = Jp+H
// module chunks = 50